import axios from "axios";
import {apiUrl, managerApiUrl} from "../common";


const apiCall = (token) =>{
    return axios.create({
       baseURL: apiUrl + "manager",
       headers: {
           "Accept": "application/json",
           "Authorization": "Bearer " + token
       }
   });
}

export const noAuthApiCall = (url) => {
    return axios.create({
        baseURL : managerApiUrl(url),
        headers : {
            "Accept" : "application/json"
        }
    })
}

export default apiCall;
